require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.json.parse.js");
const axios = require("axios");
const serverAxios = axios.create();
let serverConfig = {};
let serverConfigPromise = null;

// server.json 固定从当前前端访问域名读取，部署时只需要替换 dist/server.json。
function getBrowserServerJsonUrl() {
  const origin = typeof window !== "undefined" && window.location && window.location.origin ? window.location.origin : "";
  return `${origin}/server.json?t=${Date.now()}`;
}

// vue.config.js 运行在 Node 侧，开发代理初始化前无法请求浏览器同源地址，只能复用同一个取值接口读取模板。
function readLocalServerConfig() {
  if (typeof window !== "undefined") return {};
  try {
    const fs = require("fs");
    const path = require("path");
    return JSON.parse(fs.readFileSync(path.resolve(process.cwd(), "public/server.json"), "utf8"));
  } catch (error) {
    return {};
  }
}

// 保证 Node 侧和浏览器侧都通过同一份内存配置读取环境变量。
function getLoadedServerConfig() {
  if (!Object.keys(serverConfig).length) {
    serverConfig = readLocalServerConfig();
  }
  return serverConfig;
}

// 调用服务器上的静态配置接口，避免构建包和运行环境强绑定。
function getServerConfig() {
  if (typeof window === "undefined") {
    return Promise.resolve({
      data: readLocalServerConfig()
    });
  }
  return serverAxios.request({
    url: getBrowserServerJsonUrl(),
    method: "get"
  });
}

// 应用启动前初始化运行时环境变量，后续模块统一从内存配置读取。
async function initServerConfig() {
  if (!serverConfigPromise) {
    serverConfigPromise = getServerConfig().then(({
      data
    }) => {
      serverConfig = data || {};
      if (typeof window !== "undefined") {
        window.__SERVER_CONFIG__ = serverConfig;
      }
      return serverConfig;
    }).catch(() => {
      serverConfig = {};
      if (typeof window !== "undefined") {
        window.__SERVER_CONFIG__ = serverConfig;
      }
      return serverConfig;
    });
  }
  return serverConfigPromise;
}

// 读取单个环境变量，支持 profiles.development.api 这种点路径，空字符串按未配置处理。
function getServerConfigValue(key, fallback = "") {
  const value = String(key).split(".").reduce((configValue, configKey) => {
    if (configValue === undefined || configValue === null) return undefined;
    return configValue[configKey];
  }, getLoadedServerConfig());
  return value === undefined || value === null || value === "" ? fallback : value;
}

// 读取布尔环境变量，兼容 server.json 中字符串形式的 true/false。
function getServerConfigBoolean(key, fallback = false) {
  const value = getLoadedServerConfig()[key];
  if (value === undefined || value === null || value === "") return fallback;
  return value === true || String(value).toLowerCase() === "true";
}

// 拼接 server.json 中的服务地址和接口路径，避免出现重复斜杠。
function getServerConfigUrl(key, path = "") {
  const baseUrl = getServerConfigValue(key, "");
  if (!baseUrl) return path;
  return `${String(baseUrl).replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;
}
module.exports = {
  getServerConfig,
  initServerConfig,
  getServerConfigValue,
  getServerConfigBoolean,
  getServerConfigUrl
};